<template>
    <div class="sidebar-logo-container" :class="{'collapse':collapse}" @click="toHome">
        <div v-if="collapse" key="collapse" class="sidebar-logo-link" to="/home">
            <img v-if="logo" src="@/assets/logo.png" class="sidebar-logo">
            <h1 v-else class="sidebar-title">{{ title }} </h1>
        </div>
        <div v-else key="expand" class="sidebar-logo-link" to="/home">
            <img v-if="logo" src="@/assets/logo.png" class="sidebar-logo">
            <h1 class="sidebar-title">{{ title }} </h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SidebarLogo',
        props: {
            collapse: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                title: '万咖聚投',
                logo: '@/assets/logo.png'
            }
        },
        mounted() {
            // let path_arr = ['localhost:9000/td', 'jutou.gm825.net/td']
            let cur_href = window.location.href
            if(cur_href.indexOf('jutou.gm825.net/td') !== -1){
                this.title = '万咖聚投(测试)'
            }else{
                this.title = '万咖聚投'
            }
        },
        methods:{
            toHome(){
                // this.$router.push({path:'/home/'});
            },
        }
    }
</script>

<style lang="scss" scoped>

    .sidebar-logo-container {
        position: relative;
        width: 100%;
        height: 50px;
        line-height: 50px;
        background: #fff;
        text-align: center;
        overflow: hidden;
        box-shadow: 0 1px 4px #00152933;
        z-index: 2;

        & .sidebar-logo-link {
            height: 100%;
            width: 100%;

            & .sidebar-logo {
                width: 32px;
                height: 32px;
                vertical-align: middle;
                margin-right: 12px;
            }

            & .sidebar-title {
                display: inline-block;
                margin: 0;
                color: #333;
                font-weight: 600;
                line-height: 50px;
                font-size: 14px;
                font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
                vertical-align: middle;
            }
        }

        &.collapse {
            .sidebar-logo {
                margin-right: 0px;
            }
        }
    }
</style>
